export const GET_LALAMOVE_FEE = "GET_LALAMOVE_FEE";
